var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2428_42252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.125 5.1H18.875C19.8834 5.1 20.6357 5.47354 21.1375 6.07114C21.6413 6.67105 21.9 7.50574 21.9 8.4375V11.775H2.1V8.4375C2.1 7.50574 2.35871 6.67105 2.86248 6.07114C3.36431 5.47354 4.11659 5.1 5.125 5.1Z",
    fill: "white",
    stroke: "#DBE4F0",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 15.3125C2 17.2109 3.05406 18.75 5.125 18.75H18.875C20.9459 18.75 22 17.2109 22 15.3125V11.875H2V15.3125Z",
    fill: "#DC143C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2428_42252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlFlag);
export default __webpack_public_path__ + "static/media/PL_flag.34a643d7c8bfc6bb24e7d430a045de6f.svg";
export { ForwardRef as ReactComponent };